﻿import config from "../config"
const baseUrl = config.base_url + "z_distance_view_image/"
export default {
    insert: {
        url:  baseUrl + "insert",
        type: "post",
    },
}

